import React from 'react';
import PropTypes from 'prop-types';
import zxcvbn from 'zxcvbn';
import {FormattedMessage} from 'react-intl';

import messages from './messages';
import { formToJSON } from '../../utils/misc';
import FormField from '../../components/FormField/index';

const getProgressClass = (value) => {
    if (value < 1) {
        return 'is-danger';
    }
    else if (value < 2) {
        return 'is-warning';
    }
    else if (value < 3) {
        return 'is-info';
    }
    else if (value < 4) {
        return 'is-success';
    }

    return '';
};


class PasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.checkPasswordStrength = this.checkPasswordStrength.bind(this);
        this.validatePasswords = this.validatePasswords.bind(this);
        this.isPasswordsMatching = this.isPasswordsMatching.bind(this);

        this.state = {
            strength: -1,
            feedback: '',
            progressClass: '',
            password: '',
            statusIcon: '',
            inputClass: '',
            statusText: ''
        };
    }

    handleSubmit(e) {
        e.preventDefault();

        let data = formToJSON(this.passwordForm),
            statusText = '';

        if (!data.password || data.password === '') {
            statusText = 'Select a password';
            this.setState({ statusText });

            return false;
        }

        else if (!this.isPasswordsMatching(data)) {
            statusText = 'Passwords are not matching';
            this.setState({ statusText });

            return false;
        }

        // Remove possible old statusText
        this.setState({ statusText });

        const password = data.password;

        // Set password
        this.props.save(password);
    }

    checkPasswordStrength(event) {
        let password = event.target.value;
        let z = zxcvbn(password);

        let strength = z.score;
        let feedback = z.feedback.suggestions ? z.feedback.suggestions[0] : '';
        let progressClass = getProgressClass(strength);

        this.setState({ strength, feedback, progressClass, password });
    }

    isPasswordsMatching(data) {
        if (!data) {
            data = formToJSON(this.passwordForm);
        }

        return data.password === data.validate_password;
    }

    validatePasswords() {
        if (this.isPasswordsMatching()) {
            this.setState({ statusIcon: 'fa-check', inputClass: 'is-success'});
        }
        else {
            this.setState({statusIcon: 'fa-ban', inputClass: 'is-danger'});
        }
    }

    render() {

        let progressStyle = {
            height: '6px',
            border: '1px solid 1px solid rgb(202, 202, 202)'
        };
        let buttonClass = this.props.loading ? 'is-loading' : '';

        return (
            <form className="form" onSubmit={this.handleSubmit} ref={(form) => {
                this.passwordForm = form;
            }}>
                <FormField
                    helper={(<p className="help" style={{ height: '6px' }}>{this.state.feedback}</p>)}
                    controlClass="has-icons-left"
                    label={(<FormattedMessage {...messages.password}/>)}
                >
                    <input
                        className="input"
                        type="password"
                        name="password"
                        onChange={this.checkPasswordStrength}
                        onBlur={this.validatePasswords}
                        autoComplete="off"
                    />
                    <span className="icon is-small is-left">
                        <i className="fa fa-lock"> </i>
                    </span>

                    <div style={{margin: '8px 0'}}>
                        <progress className={`progress ${this.state.progressClass}`} value={this.state.strength + 1} max={4 + 1} style={progressStyle}> </progress>
                    </div>
                </FormField>

                <FormField
                    helper={(<p className="help is-danger" style={{ height: '6px' }}>{this.state.statusText}</p>)}
                    controlClass="has-icons-left"
                    label={(<FormattedMessage {...messages.repeatPassword}/>)}
                >
                    <input
                        className={`input ${this.state.inputClass}`}
                        type="password"
                        name="validate_password"
                        onChange={this.validatePasswords}
                        autoComplete="off"
                    />
                    <span className="icon is-small is-left">
                        <i className={`fa ${this.state.statusIcon}`}> </i>
                    </span>
                </FormField>

                <FormField>
                    <div className="submit-form" style={{margin: '40px auto 40px', width: '200px'}}>
                        <button className={`button is-info ${buttonClass}`} type="submit">
                            <FormattedMessage {...messages.submit}/>
                        </button>
                    </div>
                </FormField>
            </form>
        );
    }
}


PasswordForm.propTypes = {
    save: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default PasswordForm;
